import * as QueryString from 'query-string';

import {getGlobalHistory} from '../../util/globalHistory';
import {type NamedWorkspaceId} from './types';
import {ParamNames, type ParamNameType} from './urlTypes';

export function handleNwHistoryNavigation(
  action: 'push' | 'replace',
  nwId: NamedWorkspaceId | 'legacy'
) {
  // Don't do anything for legacy workspaces since we're removing logic soon anyways
  if (nwId === 'legacy') {
    return;
  }

  const newSearch = getNewNwUrlSearch({
    [ParamNames.nwId]: nwId.id,
  });
  if (newSearch === '') {
    // We hopefully shouldn't hit this scenario, but log if we do
    // to understand why and when.
    console.error('Unable to find new nw search for navigation.', action, nwId);
    return;
  }
  // TODO: We need to not access a global history object directly but this is a temporary
  // solution until we can refactor the code to use a more appropriate approach.
  const history = getGlobalHistory();
  if (history == null) {
    // Unset after the app unmounts under the Forge shell, e.g. when a workspace
    // finishes loading after the user has left W&B.
    return;
  }
  if (action === 'push') {
    history.push({search: newSearch});
  } else if (action === 'replace') {
    history.replace({search: newSearch});
  }
}

export function getNewNwUrlSearch(
  params: Partial<Record<ParamNameType, null | string>>
) {
  const parsedSearch = QueryString.parse(window.location.search);

  // Keep other params like PERF_LOGGING in workspaces
  const {
    [ParamNames.workspace]: discard1, // we don't want any of these params, but can't use _ more than once
    [ParamNames.username]: discard2,
    [ParamNames.nwId]: discard3,
    ...rest
  } = parsedSearch;
  const newParams = {...rest, ...params};

  return Object.keys(newParams).length > 0
    ? '?' + new URLSearchParams(QueryString.stringify(newParams)).toString()
    : '';
}
